import React from "react";
import PostStudioList from "../components/postStudio/PostStudioList";

const ManualPostStudio = () => <PostStudioList
  source="MANUAL"
  eyebrow="MANUAL POST STUDIO"
  title="Manual Post Studio"
  intro="Write, format and schedule posts yourself. Nothing here is generated by AI."
  createLabel="Create Post"
  createIcon="ti-pencil-plus"
  createPermission="user.posts.create"
  actions={["preview", "edit", "duplicate", "schedule", "publish", "delete"]}
  emptyTitle="No manual posts this month"
  emptyText="Create a post with your own copy, media and schedule."
/>;

export default ManualPostStudio;
